import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import { Link } from 'gatsby'
import { keyframes } from 'styled-components';


class AboutTwo extends React.Component {

  shouldComponentUpdate() {
    return false
  }


  render() {

    const slideInRight = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`

    const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
        `

    const AboutCol = styled(Col)`
            display: flex;
            align-items: center;
        `

    const ImageCol = styled(Col)`
            display: flex;
            align-items: center;
            justify-content: center;
            @media (max-width: 767px) {
              .image-col {
                  text-align: center;
              }
          }
        `

    const ImageWrapper = styled.div`            
      text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }      
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `
    const Main = styled.div`
            padding: 40px 0 150px 0;
            background-color: #c1eb18;
            @media (max-width: 767px) {
                padding: 100px 0;
            }
            @media (min-width: 768px) and (max-width: 1500px) {
                padding: 20px 0;
            }
            @media (min-width: 1501px) and (max-width: 1600px) {
                padding: 200px 0px;
            }            
        `
    const Heading2 = styled.h2`
            font-size: 60px;
            line-height: 70px;
            font-family: "Montserrat", sans-serif;
            color: #1b2a2f;
            font-weight: 900;
            text-transform: uppercase;            
            @media (max-width:767px) {
                font-size: 50px;
                line-height: 60px;
                text-align: left;
            }
        `

    const Heading2a = styled.h2`
          font-size: 30px;
          line-height: 30px;
          font-family: Nexa ligth,sans-serif;
          font-weight: bold;
          text-transform: uppercase;
            letter-spacing: 2px;
            @media (min-width:768px) and (max-width:1600px) {
                font-size: 20px;
                line-height: 20px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 45px;
            }
        `

    const Heading3 = styled.h3`
        font-size: 50px;
        line-height: 60px;
        font-family: "Montserrat", sans-serif;        
        font-weight: bold;        
        @media (min-width:768px) and (max-width:5000px) {
          font-size: 40px;
          line-height: 50px;
        }
        @media (max-width:767px) {
          font-size: 25px;
          line-height: 30px;
          text-align: left;
        }
        @media (min-width:5001px) and (max-width:1600px) {
          font-size: 40px;
          line-height: 50px;
          margin-top: 50px;
        }
        `

    const Headinga = styled(Link)`        
        color: #ffffff;
        transition: .5s;
          &:hover {
          color: #000;
          text-decoration: none;
        }
        `

    const Color = styled.span`
            color:  #fff;            
            font-family: "Montserrat", sans-serif;            
            letter-spacing: 2px;            
            
        `

    const ColorSan1 = styled.span`
            color: #00525e;            
        `

    const ColorSan2 = styled.span`
            color: #00A648;
        `

    const AboutContent = styled.div`
            padding: 0 20%;
            @media (max-width: 767px) {
                padding: 50px 5%;
            }
            @media (min-width: 768px) and (max-width:1200px) {
                padding: 30px 5%;
            }
            @media (min-width: 1201px) and (max-width:1600px) {
              padding: 10px 5% 90px 5%;
          }
        `

    const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color:  #000;
            margin-bottom: 20px;
        `

    const Text = styled.p`
          font-size: 18px;          
          font-weight: 300;
          color: #1a1a1a;
        `

    const Arrow = styled.p`
        position: relative;
        width: 30px; /* Ancho de la línea */
        height: 2px; /* Grosor de la línea */
        background-color: black; /* Color de la línea */
        right: -450px;
        top: -29px;
        ::after {
          content: '';
          position: absolute;
          top: -4px; /* Ajusta la posición vertical de las líneas */
          right: -1px; /* Ajusta la posición horizontal de las líneas */
          width: 10px; /* Ancho total de las líneas */
          height: 10px; /* Altura total de las líneas */
          border-top: 2px solid black; /* Grosor y color de las líneas */
          border-right: 2px solid black; /* Grosor y color de las líneas */
          transform: rotate(45deg); /* Rotación para formar la punta */
        }
        @media (max-width: 767px) {
          right: -280px;
          top: -16px;        
        }
        `
    const Animation = styled.image`
        animation: ${slideInRight} 1s ease;
        `
    const ColorV = styled.span`            
            color: #000000;            
        `
    const Heading2T = styled.h2`
      transform: translate(0px, -100px);
      transition: 1s;
      margin-top: 200px;
      font-size: 60px;
      line-height: 70px;      
      font-weight: 700;
      color: rgb(255, 255, 255);
      text-align: center;
      text-transform: uppercase;
      @media (max-width: 767px) {
          font-size: 40px;
          line-height: 50px;  
        }          
    `

    const { data } = this.props;
    console.log(data)
    // Agregar verificación para asegurarse de que los datos están disponibles
    if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
      return <div>Loading...</div>;
    }

    const prices = data.allPricesJson.nodes[0].items;

    console.log(prices)

    return (
      <Section id="san">
        <Main>
          <Row>
            
              <Container>                
                <Heading2T>Certificados Digitales <ColorV>SSL</ColorV></Heading2T>
              </Container>
            
            <AboutCol md={6}>
              <Col md={12}>

                <AboutContent>
                  <Heading2>
                    SSL <Color>SAN</Color>
                  </Heading2>
                  <Separator />
                  <Heading2a>
                    <ColorSan2>Asegure múltiples </ColorSan2>
                    <ColorSan1>Dominios, Subdominios e IPs </ColorSan1>
                    <ColorSan2>con un solo Certificado</ColorSan2>
                  </Heading2a>
                  <Text>
                    Con un solo certificado SSL SAN (Subject Alternative Name - múltiples dominios/subdominios) y Flex , puede proporcionar comunicaciones
                    seguras para varios dominios, subdominios, múltiples nombres de host, direcciones IP e incluso dominios
                    Wildcard o extensiones de dominio diferentes a la vez.
                  </Text>
                  <Text>
                    <Heading2a><ColorSan2>SSL SAN desde ${prices.find(x => x.name === 'SAN').price}</ColorSan2></Heading2a>
                  </Text>
                  <Heading3>
                    <Headinga to="/certificados-digitales-ssl-san-ucc">
                      Certificados SSL SAN <Arrow>&nbsp;</Arrow>
                    </Headinga>
                  </Heading3>
                </AboutContent>

              </Col>
            </AboutCol>
            <ImageCol md={6}>
              <Animation>
                <ImageWrapper>

                  <GatsbyImage image={this.props.image} alt="Certificados SAN SSL en Colombia" sizes="(max-width: 767px) 300px, 500px" />

                </ImageWrapper>
              </Animation>
            </ImageCol>
          </Row>
        </Main>
      </Section>
    )
  }
}

const PrecioImagen = (props) => (
  <StaticQuery
    query={graphql`
      query {
        allPricesJson(filter: { page: { eq: "inicio" }, section: { eq: "planes" } }) {
          nodes {
            items {
              name
              price
            }
          }
        }
        file(relativePath: {eq: "ssl-colombia.png"}) {
          childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
          }
        }
      }
    `}
    render={(data) => {
      const image = getImage(data.file.childImageSharp.gatsbyImageData);
      return (
        <AboutTwo
          data={data}
          image={image}
          {...props}
        />
      );
    }}
  />
);

export default PrecioImagen;
